const productosSeleccionados =
    [
    ]

export const getProductosSeleccionados = () => {
    return productosSeleccionados;
}